import { useState, useEffect } from 'react';
import { forTablet, isDesktop } from '@westwing/ui-kit/breakPoints';
import { css } from 'styled-components';
import { useAppShell, useAppshellMeta } from '@ids/appshell';

export const getInitialHeight = (isApp: boolean, isClubBarBannerShown: boolean) => {
    if (isApp) {
        return css`
            height: min(calc(100vh - 100px), 85vmax);
        `;
    }

    return css`
        height: calc(100vh - ${isClubBarBannerShown ? '184px' : '139px'});

        ${forTablet`
            height: calc(100vh - ${isClubBarBannerShown ? '255px' : '198px'});
        `}
    `;
};

const useSurveySparrowHeight = (element: HTMLElement | null) => {
    const { isApp } = useAppshellMeta();
    const { isClubBarBannerShown } = useAppShell();
    const [surveySparrowHeight, setSurveySparrowHeight] = useState(getInitialHeight(isApp, !!isClubBarBannerShown));

    useEffect(() => {
        if (element) {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            if (window.devicePixelRatio > 2 && isDesktop()) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });

                const clientSideHeight = css`
                    height: calc((var(--vh, 1vh) * 100));
                `;

                setSurveySparrowHeight(clientSideHeight);
                return;
            }

            const clientSideHeight = css`
                height: calc((var(--vh, 1vh) * 100) - ${window.pageYOffset + element.getBoundingClientRect().top}px);
            `;

            setSurveySparrowHeight(clientSideHeight);
        }
    }, [element]);

    return surveySparrowHeight;
};

export default useSurveySparrowHeight;
